/* =========================================
   NOORVA THEME - JavaScript
   ========================================= */

document.addEventListener('DOMContentLoaded', function () {

  // ── NAVBAR SCROLL ──────────────────────────────────
  const navbar = document.querySelector('.navbar');
  if (navbar) {
    window.addEventListener('scroll', () => {
      navbar.classList.toggle('scrolled', window.scrollY > 40);
    });
  }

  // ── MOBILE MENU ────────────────────────────────────
  const hamburger = document.querySelector('.navbar__hamburger');
  const mobileMenu = document.querySelector('.navbar__mobile');
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', () => {
      mobileMenu.classList.toggle('open');
    });
    mobileMenu.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => mobileMenu.classList.remove('open'));
    });
  }

  // ── SCROLL ANIMATIONS ──────────────────────────────
  const animatedEls = document.querySelectorAll('.fade-up, .fade-left, .fade-right, .fade-scale');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '-50px' });
    animatedEls.forEach(el => observer.observe(el));
  } else {
    animatedEls.forEach(el => el.classList.add('visible'));
  }

  // ── PRODUCT GALLERY ────────────────────────────────
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  const mainImage = document.querySelector('.product-gallery__main img');
  if (thumbs.length && mainImage) {
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        const newSrc = thumb.querySelector('img').src;
        mainImage.style.opacity = '0';
        setTimeout(() => {
          mainImage.src = newSrc;
          mainImage.style.opacity = '1';
        }, 200);
        mainImage.style.transition = 'opacity 0.3s';
      });
    });
  }

  // ── QUANTITY SELECTOR ──────────────────────────────
  const qtyMinus = document.querySelector('.qty-minus');
  const qtyPlus = document.querySelector('.qty-plus');
  const qtyVal = document.querySelector('.quantity-selector__val');
  const addToCartBtn = document.querySelector('.btn-add-to-cart');
  const pricePerUnit = parseFloat(document.querySelector('[data-price]')?.dataset.price || 0);

  if (qtyMinus && qtyPlus && qtyVal) {
    let qty = 1;
    const updateDisplay = () => {
      qtyVal.textContent = qty;
      if (addToCartBtn && pricePerUnit) {
        const total = (pricePerUnit * qty / 100).toFixed(2);
        addToCartBtn.textContent = `Add to Cart — $${total}`;
      }
    };
    qtyMinus.addEventListener('click', () => { if (qty > 1) { qty--; updateDisplay(); } });
    qtyPlus.addEventListener('click', () => { qty++; updateDisplay(); });
  }

  // ── ADD TO CART ────────────────────────────────────
  const cartForm = document.querySelector('.product-form');
  if (cartForm) {
    cartForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const formData = new FormData(cartForm);
      const qty = parseInt(qtyVal?.textContent || 1);
      formData.set('quantity', qty);

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });
        if (response.ok) {
          showToast('Added to cart!', 'Noorva Vitamin C Serum — 30ml');
          await refreshCartUI();
          openCart();
        }
      } catch (err) {
        console.error('Cart error:', err);
      }
    });
  }

  // ── TOAST ──────────────────────────────────────────
  function showToast(title, desc) {
    const toast = document.querySelector('.toast');
    if (!toast) return;
    toast.querySelector('.toast__title').textContent = title;
    toast.querySelector('.toast__desc').textContent = desc;
    toast.classList.add('show');
    setTimeout(() => toast.classList.remove('show'), 3500);
  }

  // ── CART DRAWER ────────────────────────────────────
  const cartDrawer = document.getElementById('cart-drawer');
  const cartOverlay = document.getElementById('cart-overlay');
  const cartClose = document.getElementById('cart-close');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  // Cart open buttons
  ['cart-btn', 'cart-btn-mobile'].forEach(id => {
    const btn = document.getElementById(id);
    if (btn) btn.addEventListener('click', () => {
      refreshCartUI().then(openCart);
    });
  });

  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  // ESC key closes cart
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeCart();
  });

  async function refreshCartUI() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();

      // Update counts
      document.querySelectorAll('.cart-count').forEach(el => {
        el.textContent = cart.item_count > 0 ? cart.item_count : '';
      });

      const cartEmpty = document.getElementById('cart-empty');
      const cartItems = document.getElementById('cart-items');
      const cartFooter = document.getElementById('cart-footer');
      const subtotalEl = document.getElementById('cart-subtotal-amount');

      if (!cartItems) return;

      if (cart.item_count === 0) {
        cartEmpty.style.display = 'flex';
        cartItems.innerHTML = '';
        if (cartFooter) cartFooter.style.display = 'none';
        return;
      }

      cartEmpty.style.display = 'none';
      if (cartFooter) cartFooter.style.display = 'block';

      if (subtotalEl) {
        subtotalEl.textContent = '$' + (cart.total_price / 100).toFixed(2);
      }

      cartItems.innerHTML = cart.items.map(item => `
        <div class="cart-item" data-key="${item.key}">
          <img class="cart-item__img" src="${item.image}" alt="${item.product_title}">
          <div>
            <p class="cart-item__name">${item.product_title}</p>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-item__variant">${item.variant_title}</p>` : ''}
            <div class="cart-item__qty">
              <button class="cart-item__qty-btn" data-key="${item.key}" data-action="decrease">−</button>
              <span>${item.quantity}</span>
              <button class="cart-item__qty-btn" data-key="${item.key}" data-action="increase">+</button>
            </div>
            <button class="cart-item__remove" data-key="${item.key}">Remove</button>
          </div>
          <p class="cart-item__price">$${(item.line_price / 100).toFixed(2)}</p>
        </div>
      `).join('');

      // Qty buttons
      cartItems.querySelectorAll('.cart-item__qty-btn').forEach(btn => {
        btn.addEventListener('click', async () => {
          const key = btn.dataset.key;
          const action = btn.dataset.action;
          const itemEl = btn.closest('.cart-item');
          const currentQty = parseInt(itemEl.querySelector('span').textContent);
          const newQty = action === 'increase' ? currentQty + 1 : Math.max(0, currentQty - 1);
          await updateCartItem(key, newQty);
        });
      });

      // Remove buttons
      cartItems.querySelectorAll('.cart-item__remove').forEach(btn => {
        btn.addEventListener('click', async () => {
          await updateCartItem(btn.dataset.key, 0);
        });
      });

    } catch (e) {
      console.error('Cart refresh error:', e);
    }
  }

  async function updateCartItem(key, qty) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      await refreshCartUI();
    } catch (e) {
      console.error('Cart update error:', e);
    }
  }

  // Initial cart count load
  refreshCartUI();

  // ── SUBSCRIBE & SAVE ───────────────────────────────
  const oneTimeBtn = document.getElementById('one-time-btn');
  const subscribeBtn = document.getElementById('subscribe-btn');

  const applySubscribePrice = () => {
    if (addToCartBtn && pricePerUnit) {
      const qty = parseInt(qtyVal?.textContent || 1);
      addToCartBtn.textContent = `Subscribe & Save — $${(pricePerUnit * qty * 0.85 / 100).toFixed(2)}`;
    }
  };
  const applyOneTimePrice = () => {
    if (addToCartBtn && pricePerUnit) {
      const qty = parseInt(qtyVal?.textContent || 1);
      addToCartBtn.textContent = `Add to Cart — $${(pricePerUnit * qty / 100).toFixed(2)}`;
    }
  };

  // Default to subscribe on load
  applySubscribePrice();

  if (oneTimeBtn && subscribeBtn) {
    oneTimeBtn.addEventListener('click', () => {
      oneTimeBtn.classList.add('active');
      subscribeBtn.classList.remove('active');
      applyOneTimePrice();
    });
    subscribeBtn.addEventListener('click', () => {
      subscribeBtn.classList.add('active');
      oneTimeBtn.classList.remove('active');
      applySubscribePrice();
    });
  }


  // ── DESCRIPTION SHOW MORE ─────────────────────────
  const descEl = document.getElementById('product-desc');
  const descToggle = document.getElementById('desc-toggle');
  if (descEl && descToggle) {
    // Only show toggle if text is actually clamped
    const checkClamped = () => descEl.scrollHeight > descEl.clientHeight + 2;
    if (!checkClamped()) descToggle.style.display = 'none';

    descToggle.addEventListener('click', () => {
      const expanded = descToggle.getAttribute('aria-expanded') === 'true';
      descEl.classList.toggle('expanded', !expanded);
      descToggle.setAttribute('aria-expanded', String(!expanded));
      descToggle.childNodes[0].textContent = expanded ? 'Show more ' : 'Show less ';
    });
  }

});
